export const FETCH_USER = 'fetch_user';
export const FETCH_PAYMENT_DETAILS = 'fetch_payment_details';
export const FETCH_REVIEWS = 'fetch_reviews';
export const WAITING = 'waiting';
export const ERROR = 'ERROR';
export const NOTIFICATION = 'NOTIFICATION';
export const FETCH_GOOGLE_PLACES = 'fetch_google_places';
export const REVIEW_REQUESTS = 'review_requests';
export const REVIEW_RESPONSE_TEMPLATES = 'REVIEW_RESPONSE_TEMPLATES';
export const REVIEW_RESPONSE_PREFERRED_STYLE = 'REVIEW_RESPONSE_PREFERRED_STYLE';
export const BRAND_COLORS = 'BRAND_COLORS';
export const GET_TEMPLATES = 'GET_TEMPLATES';
export const SET_USERS = 'SET_USERS';
export const SET_USER_ONLINE = 'SET_USER_ONLINE';
export const SET_USER_OFFLINE = 'SET_USER_OFFLINE';
export const CANCEL_ACCOUNT = 'CANCEL_ACCOUNT';
export const UPGRADE_ACCOUNT = 'UPGRADE_ACCOUNT';
export const UPDATE_CHATBOX_HEIGHT = 'UPDATE_CHATBOX_HEIGHT';
export const SET_SELECTED_CONVERSATIONS = 'SET_SELECTED_CONVERSATIONS';
export const SET_TRANSCRIPT_VIEW = 'SET_TRANSCRIPT_VIEW';
export const SET_SHOW_CONVERSATION_DETAILS = 'SET_SHOW_CONVERSATION_DETAILS';

export const SET_TAGS = 'SET_TAGS';
export const ADD_TAG = 'ADD_TAG';

export const SET_MESSAGE_AUTOMATIONS = 'SET_MESSAGE_AUTOMATIONS';

// Pay
export const HAS_STRIPE_ACCOUNT = 'HAS_STRIPE_ACCOUNT';
export const SET_FILTERED_INVOICES = 'SET_FILTERED_INVOICES';
export const SET_CUSTOMER_INVOICES = 'SET_CUSTOMER_INVOICES';
export const SET_ALL_INVOICES = 'SET_ALL_INVOICES';
export const SET_TOTAL_INVOICES = 'SET_TOTAL_INVOICES';
export const HAS_MORE_INVOICES = 'HAS_MORE_INVOICES';
// Opaque Stripe search page cursor used only on the status-filtered Pay path
export const SET_INVOICES_NEXT_CURSOR = 'SET_INVOICES_NEXT_CURSOR';
export const APPEND_INVOICES = 'APPEND_INVOICES';
export const APPEND_CUSTOMER_INVOICES = 'APPEND_CUSTOMER_INVOICES';
export const SET_ALL_CUSTOMER_INVOICES = 'SET_ALL_CUSTOMER_INVOICES';
export const HAS_DETAILS_SUBMITTED = 'HAS_DETAILS_SUBMITTED';
export const ACTIVE_DASHBOARD = 'ACTIVE_DASHBOARD';

// typing indicator
export const ADD_TYPING_INDICATOR = 'ADD_TYPING_INDICATOR';
export const REMOVE_TYPING_INDICATOR = 'REMOVE_TYPING_INDICATOR';

// Departments
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';

// Business Group
export const SET_BUSINESS_GROUP = 'SET_BUSINESS_GROUP';
export const SET_WEBCHAT_LOCATIONS = 'SET_WEBCHAT_LOCATIONS';

// Teams
export const SET_TEAM_CONVERSATIONS = 'SET_TEAM_CONVERSATIONS';
export const SET_ACTIVE_TEAM_CONVERSATION = 'SET_ACTIVE_TEAM_CONVERSATION';
export const ADD_TEAM_CONVERSATION = 'ADD_TEAM_CONVERSATION';
export const ADD_MESSAGE_TO_TEAM_CONVERSATION =
	'ADD_MESSAGE_TO_TEAM_CONVERSATION';
export const CHANGE_CONVERSATION_TITLE = 'CHANGE_CONVERSATION_TITLE';
export const UPDATE_TEAM_CONVERSATION = 'UPDATE_TEAM_CONVERSATION';
export const ADD_MESSAGES_TO_TEAM_CONVERSATION =
	'ADD_MESSAGES_TO_TEAM_CONVERSATION';
export const REPLACE_MESSAGES_IN_TEAM_CONVERSATION =
	'REPLACE_MESSAGES_IN_TEAM_CONVERSATION';
export const REMOVE_TEAM_CONVERSATION = 'REMOVE_TEAM_CONVERSATION';

export const SET_ACTIVE_TEAM_CONVERSATION_TO_NULL =
	'SET_ACTIVE_TEAM_CONVERSATION_TO_NULL';
export const APPEND_TEAM_CONVERSATIONS = 'APPEND_TEAM_CONVERSATIONS';
export const UPDATE_TEAM_MESSAGE = 'UPDATE_TEAM_MESSAGE';
export const SET_TEAM_REPLY = 'SET_TEAM_REPLY';

// browser notifications
export const SET_BROWSER_NOTIFICATION_PERMISSION_STATUS =
	'SET_BROWSER_NOTIFICATION_PERMISSION_STATUS';

// display notification
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

// Folders
export const SET_FOLDERS = 'SET_FOLDERS';
export const ADD_FOLDER = 'ADD_FOLDER';
export const REMOVE_FOLDER = 'REMOVE_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';

// Template folders
export const SET_TEMPLATE_FOLDERS = 'SET_TEMPLATE_FOLDERS';
export const ADD_TEMPLATE_FOLDER = 'ADD_TEMPLATE_FOLDER';
export const REMOVE_TEMPLATE_FOLDER = 'REMOVE_TEMPLATE_FOLDER';
export const UPDATE_TEMPLATE_FOLDER = 'UPDATE_TEMPLATE_FOLDER';

// A2P Compliance
export const SET_A2P_COMPLIANCE_STATUS = 'SET_A2P_COMPLIANCE_STATUS';
export const GET_A2P_COMPLIANCE_STATUS = 'GET_A2P_COMPLIANCE_STATUS';

// Customer Conversations
export const LOADING = 'LOADING';
export const SET_CUSTOMER_CONVERSATIONS = 'SET_CUSTOMER_CONVERSATIONS';
export const ADD_CUSTOMER_CONVERSATION = 'ADD_CUSTOMER_CONVERSATION';
export const UPDATE_CUSTOMER_CONVERSATION = 'UPDATE_CUSTOMER_CONVERSATION';
export const REMOVE_CUSTOMER_CONVERSATION = 'REMOVE_CUSTOMER_CONVERSATION';
export const SET_CUSTOMER_CONVERSATION_MESSAGES =
	'SET_CUSTOMER_CONVERSATION_MESSAGES';
export const ADD_CUSTOMER_CONVERSATION_MESSAGE =
	'ADD_CUSTOMER_CONVERSATION_MESSAGE';
export const LOADING_MORE_CUSTOMER_CONVERSATIONS =
	'LOADING_MORE_CUSTOMER_CONVERSATIONS';
export const OPEN_CONVERSATIONS_SELECTED = 'OPEN_CONVERSATIONS_SELECTED';
export const SET_CUSTOMER_CONVERSATION_ASSIGNED_TYPE =
	'SET_CUSTOMER_CONVERSATION_ASSIGNED_TYPE';
export const SHOW_ONLY_UNREAD_CONVERSATIONS = 'SHOW_ONLY_UNREAD_CONVERSATIONS';
export const SET_CUSTOMER_CONVERSATION_CHANNEL_FILTER =
	'SET_CUSTOMER_CONVERSATION_CHANNEL_FILTER';
export const SET_CUSTOMER_CONVERSATIONS_LAST_SYNCED_AT =
	'SET_CUSTOMER_CONVERSATIONS_LAST_SYNCED_AT';
export const SET_ACTIVE_CONVERSATION = 'SET_ACTIVE_CONVERSATION';
export const UPSERT_CUSTOMER_CONVERSATION = 'UPSERT_CUSTOMER_CONVERSATION';
export const SET_SOCKET_ID = 'SET_SOCKET_ID';

// Optimistic send
export const ADD_OPTIMISTIC_MESSAGE = 'ADD_OPTIMISTIC_MESSAGE';
export const FAIL_OPTIMISTIC_MESSAGE = 'FAIL_OPTIMISTIC_MESSAGE';
export const REMOVE_OPTIMISTIC_MESSAGE = 'REMOVE_OPTIMISTIC_MESSAGE';
export const SET_COMPOSER_RESTORE = 'SET_COMPOSER_RESTORE';
export const CLEAR_COMPOSER_RESTORE = 'CLEAR_COMPOSER_RESTORE';

// runner ui
export const TOGGLE_PIPELINE_SHEET = 'TOGGLE_PIPELINE_SHEET';

// reminders
export const SET_REMINDERS = 'SET_REMINDERS';
export const CREATE_REMINDER = 'CREATE_REMINDER';
export const UPDATE_REMINDER = 'UPDATE_REMINDER';
export const DELETE_REMINDER = 'DELETE_REMINDER';
export const SET_REMINDERS_LOADING = 'SET_REMINDERS_LOADING';
export const SET_REMINDERS_ERROR = 'SET_REMINDERS_ERROR';

// opportunities
export const SET_OPPORTUNITIES_SETTINGS = 'SET_OPPORTUNITIES_SETTINGS';
export const SET_OPPORTUNITY_STATUS_LABEL = 'SET_OPPORTUNITY_STATUS_LABEL';
export const SET_ALL_OPPORTUNITY_STATUS_LABELS =
	'SET_ALL_OPPORTUNITY_STATUS_LABELS';
export const SET_OPPORTUNITIES_LOADING = 'SET_OPPORTUNITIES_LOADING';
export const SET_OPPORTUNITIES_ERROR = 'SET_OPPORTUNITIES_ERROR';

// forms
export const SET_FORMS = 'SET_FORMS';
export const SET_FORMS_LOADING = 'SET_FORMS_LOADING';
export const SET_FORMS_ERROR = 'SET_FORMS_ERROR';
